module.exports = __webpack_public_path__ + "img/course.386868a7.jpg";